<template>
  <div class="timed-task">
    <div v-if="visibleDetail" class="timed-task-content">
      <el-card class="box-card form-card">
        <div class="form-options">
          <el-row>
            <el-button icon="el-icon-plus" class="add-btn" @click="addTask"
              >新增</el-button
            >
            <!-- <el-button
              icon="el-icon-edit"
              class="edit-disabled-btn"
              disabled
              v-if="showEditButton"
              >修改</el-button
            >
            <el-button
              icon="el-icon-edit"
              class="edit-btn"
              v-else
              @click="editCheckedForm"
              >修改</el-button
            > -->
            <el-button
              icon="el-icon-delete"
              class="delete-btn"
              disabled
              v-if="showDeleteButton"
              >删除</el-button
            >
            <el-button
              icon="el-icon-delete"
              type="danger"
              v-else
              @click="deleteCheckedForm"
              >删除</el-button
            >
            <el-button
              icon="el-icon-s-order"
              class="journal-btn"
              @click="showDailyContent"
              >日志</el-button
            >
          </el-row>
        </div>
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
          v-loading="timeLoading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          style="max-height: calc(100vh - 20px); width: 100%; mix-height: 240px"
        >
          <el-table-column type="selection"></el-table-column>
          <el-table-column prop="quartzId" label="任务编号"> </el-table-column>
          <el-table-column prop="jobName" label="任务名称"> </el-table-column>
          <el-table-column
            prop="jobGroup"
            label="任务分组"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="cronExpression"
            label="执行表达式"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="任务状态" porp="status">
            <template slot-scope="scope">
              <el-switch
                :value="scope.row.status"
                active-color="#ff4949"
                inactive-color="#13ce66"
                active-value="1"
                inactive-value="2"
                @change="changeState(scope.row)"
                :formatter="formState(scope.row)"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            prop="startTime"
            label="创建时间"
            sortable
            width="250"
          >
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button
                class="edit-btn1"
                size="mini"
                icon="el-icon-edit"
                @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
              <el-button
                class="delete-btn1"
                size="mini"
                icon="el-icon-delete"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChangeTask"
            @current-change="handleCurrentChangeTask"
            :current-page.sync="currentPageTask"
            :page-size="pageSizeTask"
            layout="total, prev, pager, next"
            :total="totalSizeTask"
          >
          </el-pagination>
        </div>
      </el-card>
      <el-dialog
        :visible.sync="editDialogVisible"
        width="50%"
        :before-close="handleCloseEdit"
        :title="dialogTitle"
      >
        <section>
          <el-form
            :model="ruleFormEdit"
            :rules="editRules"
            ref="editTimedTaskForm"
            label-width="100px"
            class="demo-ruleForm no-flex-form"
          >
            <el-form-item label="任务名称：" prop="jobName" required>
              <el-input v-model="ruleFormEdit.jobName"></el-input>
            </el-form-item>
            <el-form-item label="任务分组：" prop="jobGroup" required>
              <el-select
                v-model="ruleFormEdit.jobGroup"
                placeholder="JobForGraduate"
                style="width: 100%"
              >
                <el-option
                  label="JobForGraduate"
                  value="JobForGraduate"
                ></el-option>
                <el-option
                  label="JobForStudent"
                  value="JobForStudent"
                ></el-option>
                <el-option
                  label="JobForTeacher"
                  value="JobForTeacher"
                ></el-option>
                <el-option
                  label="JobForEmployTeacher"
                  value="JobForEmployTeacher"
                ></el-option>
                <el-option
                  label="JobForOrganize"
                  value="JobForOrganize"
                ></el-option>
                <el-option label="JobForYkt" value="JobForYkt"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="corn表达式：" prop="cronExpression" required>
              <el-input v-model="ruleFormEdit.cronExpression"></el-input>
            </el-form-item>
            <el-form-item label="开始时间：" prop="startTime" required>
              <el-date-picker
                value-format="yyyy-MM-dd hh:mm:ss"
                type="datetime"
                placeholder="选择日期时间"
                v-model="ruleFormEdit.startTime"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-form>
        </section>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">关 闭</el-button>
          <el-button type="primary" @click="editTaskList">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        :visible.sync="addDialogVisible"
        width="50%"
        :before-close="handleClose"
        :title="dialogTitle"
      >
        <section>
          <el-form
            :model="ruleForm"
            :rules="editRules"
            ref="addTimedTaskForm"
            label-width="100px"
            class="demo-ruleForm no-flex-form"
          >
            <el-form-item label="任务名称：" prop="jobName" required>
              <el-input v-model="ruleForm.jobName"></el-input>
            </el-form-item>
            <el-form-item label="任务分组：" prop="jobGroup" required>
              <el-select
                v-model="ruleForm.jobGroup"
                placeholder="JobForGraduate"
                style="width: 100%"
              >
                <el-option
                  label="JobForGraduate"
                  value="JobForGraduate"
                ></el-option>
                <el-option
                  label="JobForStudent"
                  value="JobForStudent"
                ></el-option>
                <el-option
                  label="JobForTeacher"
                  value="JobForTeacher"
                ></el-option>
                <el-option
                  label="JobForEmployTeacher"
                  value="JobForEmployTeacher"
                ></el-option>
                <el-option
                  label="JobForOrganize"
                  value="JobForOrganize"
                ></el-option>
                <el-option label="JobForYkt" value="JobForYkt"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="corn表达式：" prop="cronExpression" required>
              <el-input v-model="ruleForm.cronExpression"></el-input>
            </el-form-item>
            <el-form-item label="开始时间：" prop="startTime" required>
              <el-date-picker
                value-format="yyyy-MM-dd hh:mm:ss"
                type="datetime"
                placeholder="选择日期时间"
                v-model="ruleForm.startTime"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-form>
        </section>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">关 闭</el-button>
          <el-button type="primary" @click="addTaskList">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <div class="daily-record" v-else>
      <el-card class="box-card form-card">
        <div class="form-options">
          <el-row>
            <el-button
              icon="el-icon-close"
              class="delete-btn"
              disabled
              v-if="showDailyDelateBtn"
              >删除</el-button
            >
            <el-button
              icon="el-icon-close"
              type="danger"
              v-else
              @click="editDailyCheckedForm"
              >删除</el-button
            >
            <el-button type="danger" icon="el-icon-delete" @click="clearAll"
              >清空</el-button
            >
            <el-button icon="el-icon-back" class="close-btn" @click="onClose"
              >关闭</el-button
            >
          </el-row>
          <el-scrollbar style="height: 100%">
            <el-table
              ref="multipleTable"
              :data="dailyTableData"
              tooltip-effect="dark"
              @selection-change="handleDailySelectionChange"
              style="max-height: calc(100vh - 200px); width: 100%"
              height="500"
              v-loading="dailyLoading"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
            >
              <el-table-column type="selection"> </el-table-column>
              <el-table-column prop="id" label="日志编号"> </el-table-column>
              <el-table-column prop="dataSource" label="数据来源">
              </el-table-column>
              <el-table-column
                prop="targetSystem"
                label="目标系统"
              ></el-table-column>
              <el-table-column
                prop="jsonData"
                label="数据内容"
                width="200"
              ></el-table-column>
              <el-table-column prop="msg" label="日志信息"></el-table-column>
              <el-table-column
                prop="operType"
                label="操作类型"
              ></el-table-column>
              <el-table-column label="状态">
                <template slot-scope="scope">
                  <el-tag
                    size="medium"
                    class="state-tag"
                    v-if="scope.row.status == '0'"
                    >成功</el-tag
                  >
                  <el-tag size="medium" class="state-tag error-state" v-else>
                    失败
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" label="创建时间" sortable>
              </el-table-column>
              <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    icon="el-icon-s-open"
                    @click="repeatState(scope.$index, scope.row)"
                    v-show="scope.row.status == '1'"
                    type="danger"
                    >重发</el-button
                  >
                  <el-button
                    class="detail-btn"
                    size="mini"
                    icon="el-icon-search"
                    @click="showDetail(scope.$index, scope.row)"
                    >详情</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-scrollbar>
          <div class="pagination">
            <el-pagination
              @size-change="handleSizeChangeDetail"
              @current-change="handleCurrentChangeDetail"
              :current-page.sync="currentPageDetail"
              :page-size="pageSizeDetail"
              layout="total, prev, pager, next"
              :total="totalSizeDetail"
            >
            </el-pagination>
          </div>
        </div>
        <el-dialog
          :visible.sync="editDailyDialogVisible"
          width="50%"
          :before-close="handleCloseDailyDetail"
          title="调度日志详细"
        >
          <section>
            <el-form
              :model="ruleDailyForm"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm no-flex-form1"
            >
              <el-form-item label="日志编号：" prop="id">
                <el-input v-model="ruleDailyForm.id"></el-input>
              </el-form-item>
              <el-form-item label="目标系统：" prop="targetSystem">
                <el-input v-model="ruleDailyForm.targetSystem"></el-input>
              </el-form-item>
              <el-form-item label="数据内容：" prop="jsonData">
                <el-input
                  v-model="ruleDailyForm.jsonData"
                  type="textarea"
                ></el-input>
              </el-form-item>
              <el-form-item label="日志信息：" prop="msg">
                <el-input v-model="ruleDailyForm.msg"></el-input>
              </el-form-item>
              <el-form-item label="操作类型：" prop="operType">
                <el-input v-model="ruleDailyForm.operType"></el-input>
              </el-form-item>
              <el-form-item label="状态：" prop="status">
                <el-input
                  :value="ruleDailyForm.status == '0' ? '成功' : '失败'"
                ></el-input>
              </el-form-item>
            </el-form>
          </section>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="editDailyDialogVisible = false"
              >关 闭</el-button
            >
          </span>
        </el-dialog>
      </el-card>
    </div>
  </div>
</template>

<script>
import {
  getTimedTaskList,
  addTimedTaskList,
  editTimedTaskList,
  deleteTimedTaskList,
  resumeTimedTaskList,
  pauseTimedTaskList,
  getLogsList,
  repeatLogsList,
  deleteDailyList,
  validateCorn,
} from '@/api/xigongda';
import { isValidCron } from 'cron-validator';
export default {
  data() {
    //校验是否为cron表达式
    var handleCronValidate = (rule, value, callback) => {
      if (!!value) {
        // let parser = require('cron-parser');
        // try {
        //   // let interval = parser.parseExpression(value);
        //   let code;
        //   this.validateCorn(value).then((res) => {
        //     code = res;
        //     console.log(code);
        //     if (code === -1) {
        //       throw '非Cron表达式格式，请检查！';
        //     }
        //   });
        // } catch (e) {
        //   callback('非Cron表达式格式，请检查！' + e.message);
        // }
        let code;
        this.validateCorn(value).then((res) => {
          code = res;
          if (code === -1) {
            return callback('非Cron表达式格式，请检查！');
          } else {
            callback();
          }
        });
      } else {
        callback('Cron表达式不能为空！');
      }
    };
    return {
      timeLoading: true,
      dailyLoading: true,
      // 删除存储quartzIds
      quartzIds: [],
      // 删除存储logIds
      logIds: [],
      // 当前页
      currentPageTask: 1,
      // 一页显示多少条
      pageSizeTask: 10,
      // 总页数
      totalSizeTask: 100,
      form: {
        name: '',
        region: '',
        state: '',
      },
      tableData: [
        {
          quartzId: '1111',
          jobName: 'ahahah',
          jobGroup: 'wdwedew',
          cronExpression: 'dewferf',
          status: '1',
          startTime: '2021-08-20 09:30:09',
        },
      ],
      // 控制编辑弹出框的显示与消失
      editDialogVisible: false,
      addDialogVisible: false,
      editRules: {
        jobName: [{ message: '请输入任务名称', trigger: 'change' }],
        jobGroup: [{ message: '请选择任务分组', trigger: 'change' }],
        cronExpression: [
          { required: true, validator: handleCronValidate, trigger: 'blur' },
        ],
        startTime: [
          {
            message: '请选择开始时间',
            trigger: 'change',
          },
        ],
      },
      ruleForm: {
        jobName: '',
        jobGroup: 'JobForGraduate',
        startTime: '',
        cronExpression: '',
        invokeParam: '',
      },
      ruleFormEdit: {
        id: '',
        jobName: '',
        jobGroup: 'JobForGraduate',
        startTime: '',
        cronExpression: '',
        invokeParam: '',
      },
      // 当前页数
      currentPage: undefined,
      // 控制编辑按钮是否禁用
      showEditButton: true,
      // 控制删除按钮是否禁用
      showDeleteButton: true,
      dialogTitle: '',
      // 表格选中的数据进行存储起来
      saveCheckedForm: {},
      saveCheckForms: [],
      // 记录选中几条数据
      dataNum: undefined,
      // 控制日志是否显示
      visibleDetail: true,

      // 详情页当前页
      currentPageDetail: 1,
      // 详情页一页显示多少条
      pageSizeDetail: 10,
      // 详情页总页数
      totalSizeDetail: 100,
      showDailyDelateBtn: true,
      editDailyDialogVisible: false,
      // 日志表格数据
      dailyTableData: [
        {
          num1: '1',
          num2: '哈哈哈哈',
          num3: '默认',
          num4: 'shadhpoadhoa',
          num5: '挥洒还查我删除文档',
          num6: '失败',
          num7: '2021-09-28 15:10:15',
        },
      ],
      // 被选中的表单项数量
      dataDailyNum: undefined,
      saveDailyCheckForms: [],
      // 表单项的详细信息
      ruleDailyForm: {},
    };
  },

  mounted() {
    this.getTimedTask();
  },
  methods: {
    // 验证corn
    validateCorn(value) {
      let data = {
        corn: value,
      };
      return validateCorn(data).then((res) => res.code);
    },
    handleSizeChangeTask(val) {},
    handleCurrentChangeTask(val) {
      this.currentPageTask = val;
      this.getTimedTask();
      // this.fetchSalaryList();
    },
    // 显示日志的表单内容
    showDailyContent() {
      this.visibleDetail = false;
      this.timeLoading = true;
      this.getLogsList();
    },
    // 每行的编辑任务
    handleEdit(a, b) {
      this.editDialogVisible = true;
      this.ruleFormEdit = JSON.parse(JSON.stringify(b));
      this.dialogTitle = '修改任务';
    },
    // 每行的删除
    handleDelete(a, b) {
      // console.log(a, b);
      this.quartzIds = [];
      this.quartzIds.push(b.quartzId);
      this.$confirm('确定删除该条任务信息吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let data = {
            quartzIds: this.quartzIds,
          };
          deleteTimedTaskList(data).then((res) => {
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '删除成功!',
              });
              this.getTimedTask();
              this.quartzIds = [];
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    // 选中框选中的时候触发的事件
    handleSelectionChange(val) {
      if (val.length == 1) {
        this.showEditButton = false;
        this.saveCheckedForm = val[0];
        this.showDeleteButton = false;
        this.saveCheckForms = val;
        this.dataNum = val.length;
      } else if (val.length > 1) {
        this.showDeleteButton = false;
        this.saveCheckForms = val;
        this.dataNum = val.length;
      } else {
        this.showEditButton = true;
        this.showDeleteButton = true;
      }
    },
    // 修改被选中的表格项
    // editCheckedForm() {
    //   this.editDialogVisible = true;
    //   this.ruleForm = this.saveCheckedForm;
    //   this.dialogTitle = '修改任务';
    // },
    // 删除被选中的表格项
    deleteCheckedForm() {
      // console.log(this.saveCheckForms);
      this.saveCheckForms.map((item) => {
        this.quartzIds.push(item.quartzId);
      });
      this.$confirm(`确定删除选中的${this.dataNum}条数据吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let data = {
            quartzIds: this.quartzIds,
          };
          deleteTimedTaskList(data).then((res) => {
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '删除成功!',
              });
              this.getTimedTask();
              this.quartzIds = [];
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    handleCloseEdit() {
      this.editDialogVisible = false;
      this.ruleForm = {
        jobName: '',
        jobGroup: 'JobForGraduate',
        startTime: '',
        cronExpression: '',
        invokeParam: '',
      };
    },
    handleClose() {
      this.addDialogVisible = false;
      this.ruleForm = {
        jobName: '',
        jobGroup: 'JobForGraduate',
        startTime: '',
        cronExpression: '',
        invokeParam: '',
      };
    },
    handleCurrentChange() {},
    // 新增任务
    addTask() {
      this.addDialogVisible = true;
      this.dialogTitle = '添加任务';
    },
    // 获取列表数据
    getTimedTask() {
      let data = {
        pageNum: this.currentPageTask,
        pageSize: this.pageSizeTask,
      };
      getTimedTaskList(data).then((res) => {
        this.tableData = res.data.list;
        this.totalSizeTask = res.data.total;
        this.timeLoading = false;
        // console.log(this.tableData);
      });
    },

    addTaskList() {
      this.$refs.addTimedTaskForm.validate(async (valid) => {
        if (!valid) return false;
        this.addDialogVisible = false;
        this.ruleForm.invokeParam = this.ruleForm.jobGroup;
        // console.log(this.ruleForm);
        let data = { ...this.ruleForm };
        // data = JSON.stringify(data);
        addTimedTaskList(data).then((res) => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '添加成功!',
            });
            this.getTimedTask();
            this.ruleForm = {
              id: '',
              jobName: '',
              jobGroup: 'JobForGraduate',
              startTime: '',
              cronExpression: '',
              invokeParam: '',
            };
          }
        });
      });
    },
    editTaskList() {
      this.$refs.editTimedTaskForm.validate(async (valid) => {
        if (!valid) return false;
        this.editDialogVisible = false;
        let data = { ...this.ruleFormEdit };
        editTimedTaskList(data).then((res) => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '修改成功!',
            });
            this.getTimedTask();
          }
        });
      });
    },
    // 点击改变状态
    changeState(row) {
      this.quartzIds.push(row.quartzId);
      if (row.status == '0') {
        this.$confirm('确定暂停该条任务吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            let data = {
              quartzIds: this.quartzIds,
            };
            pauseTimedTaskList(data).then((res) => {
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '修改成功!',
                });
                this.getTimedTask();
                this.quartzIds = [];
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消修改',
            });
          });
      } else {
        this.$confirm('确定恢复该条任务吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            let data = {
              quartzIds: this.quartzIds,
            };
            resumeTimedTaskList(data).then((res) => {
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '修改成功!',
                });
                this.getTimedTask();
                this.quartzIds = [];
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消修改',
            });
          });
      }
    },
    // 对状态字段进行格式化
    formState(row, column, cellValue, index) {
      if (row.status == '0') {
        return true;
      } else if (row.status == '1') {
        return false;
      }
    },
    /*
     * 调度的方法
     *
     *
     */
    handleSizeChangeDetail(val) {},
    // 分页效果
    handleCurrentChangeDetail(val) {
      this.currentPageDetail = val;
      this.getLogsList();
    },
    // 展示详情
    showDetail(a, b) {
      this.editDailyDialogVisible = true;
      this.ruleDailyForm = b;
    },
    // 选中表格的复选框触发
    handleDailySelectionChange(val) {
      if (val.length > 0) {
        this.showDailyDelateBtn = false;
        this.saveDailyCheckForms = val;
        this.dataDailyNum = val.length;
      } else {
        this.showDailyDelateBtn = true;
      }
    },
    // 修改被选中的日志表单项
    editDailyCheckedForm() {
      this.logIds = [];
      this.saveDailyCheckForms.map((item) => {
        this.logIds.push(item.id);
      });
      this.$confirm(`确定删除选中的${this.dataDailyNum}条数据吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let data = {
            logIds: this.logIds,
          };
          deleteDailyList(data).then((res) => {
            console.log(data);
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '删除成功!',
              });
              this.getLogsList();
              this.logIds = [];
              this.saveDailyCheckForms = [];
            }
          });
        })
        .catch(() => {
          this.logIds = [];
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    // 清空所有调度
    clearAll() {
      let data = {
        logIds: [],
      };
      this.$confirm('确定清空所有调度日志吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          deleteDailyList(data).then((res) => {
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '清空成功!',
              });
              this.getLogsList();
              this.logIds = [];
              this.saveDailyCheckForms = [];
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消清空',
          });
        });
    },
    handleCloseDailyDetail() {
      this.editDailyDialogVisible = false;
    },
    onClose() {
      this.visibleDetail = true;
      this.dailyLoading = true;
      this.getTimedTask();
    },
    // 失败的时候，点击重发状态
    repeatState(a, b) {
      let data = {
        id: b.id,
      };
      this.$confirm(`确定重发该条数据吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          console.log(1111);
          repeatLogsList(data).then((res) => {
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '重发成功!',
              });
              this.getLogsList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消重发',
          });
        });
    },
    // 日志列表数据
    getLogsList() {
      let data = {
        pageNum: this.currentPageDetail,
        pageSize: this.pageSizeDetail,
      };
      getLogsList(data).then((res) => {
        this.dailyTableData = res.data.list;
        this.totalSizeDetail = res.data.total;
        this.dailyLoading = false;
      });
    },
    formDailyState(row, column, cellValue, index) {
      console.log(row);
      if (row.status == '0') {
        return '成功';
      } else if (row.status == '1') {
        return '失败';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.timed-task {
  margin-left: 50px;
  margin-top: 50px;
  /deep/.edit-btn {
    background: rgb(24, 166, 137);
  }
  /deep/.el-form {
    display: flex;
  }
  /deep/.el-input__inner::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #333;
  }
  /deep/.el-input__inner:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #333;
  }
  /deep/.el-input__inner::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #333;
  }
  /deep/.el-input__inner:-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #333;
  }
  /deep/.el-form-item__label {
    width: 90px !important;
  }
  /deep/.el-form-item__content {
    margin-left: 90px !important;
  }
  /deep/.el-button {
    height: 40px;
    margin-left: 10px;
  }
  .form-card {
    margin-top: 10px;
    .form-options {
      display: flex;
      justify-content: space-between;
    }
    /deep/.el-button {
      color: #fff !important;
    }
    .add-btn {
      background: rgb(28, 132, 198);
    }
    .edit-disabled-btn {
      background: rgb(109, 217, 195);
    }
    .delete-btn {
      background: rgb(245, 157, 166);
    }
    .journal-btn {
      background: rgb(35, 198, 200);
    }
    /deep/.el-icon-download {
      font-weight: bold;
    }
    .right-options {
      /deep/.el-button {
        color: #333 !important;
        margin-left: 0px;
        border-radius: 0;
        width: 66px;
        height: 40px;
        font-size: 18px;
      }
      /deep/.el-button:nth-of-type(n + 2) {
        border-left: none;
      }
    }
  }
  /deep/.el-table {
    margin-top: 15px;
  }
  /deep/.ascending {
    border-bottom-color: #fff !important;
  }
  /deep/.cell {
    /deep/.el-button {
      color: #fff;
      .delete-btn1 {
        background: red;
      }
    }
    .more-btn {
      background: rgb(35, 198, 200);
    }
    .edit-btn1 {
      background: rgb(28, 132, 198);
    }
  }
  .pagination {
    margin-top: 15px;
    display: flex;
    align-items: center;
  }
  .no-flex-form {
    display: flex !important;
    flex-direction: column !important;
    /deep/.el-form-item__label {
      width: 140px !important;
    }
    /deep/.el-form-item__content {
      margin-left: 140px !important;
    }
  }
  /deep/.is-light {
    background: #fff !important;
    height: 26px;
  }
  .icon-whtie {
    /deep/.el-icon-close {
      color: #fff !important;
    }
  }
  /deep/.el-dialog {
    /deep/.el-input__inner {
      width: 760px !important;
    }
  }
}
</style>

<style scoped lang="scss">
.daily-record {
  /deep/.el-button {
    color: #fff;
  }
  /deep/.form-options {
    display: flex;
    flex-direction: column;
  }
  /deep/.el-icon-close {
    font-weight: bold;
  }
  /deep/.el-icon-delete {
    font-weight: bold;
  }
  /deep/.el-icon-back {
    font-weight: bold;
  }
  .delete-btn {
    background: rgb(245, 157, 166);
  }
  .close-btn {
    background: rgb(248, 172, 89);
  }
  /deep/.detail-btn {
    background: rgb(248, 172, 89);
  }
  /deep/.el-icon-search {
    font-weight: bold;
  }
  .state-tag {
    background: rgb(26, 179, 148);
    color: #fff;
    border-radius: 20px;
  }
  .error-state {
    background: #f56c6c;
  }
  /deep/.el-button.is-disabled:hover {
    background: rgb(245, 157, 166) !important;
    color: #fff;
  }
  .no-flex-form1 {
    display: flex !important;
    flex-direction: column !important;
    /deep/.el-form-item__label {
      width: 140px !important;
    }
    /deep/.el-form-item__content {
      margin-left: 140px !important;
    }
  }
  /deep/.el-form:nth-last-child(5) {
    background: #1ab394;
    // /deep/.el-input__inner {
    //   background: #1ab394;
    //   color: #fff;
    //   border-radius: 20px;
    //   height: 28px;
    //   line-height: 26px;
    //   width: 46px;
    // }
  }
  /deep/.el-input__inner {
    border: 0 !important;
  }
  /deep/.el-textarea__inner {
    border: 0;
    resize: none;
    height: auto;
  }
}
</style>